import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import Input from '../../Input/Input.js';
import { LABELLED_INPUT_CATEGORY_KEY, LABELLED_INPUT_COMPONENT_KEY } from '../LabelledInput.meta.js';

export default InjectedStyledComponent(Input, LABELLED_INPUT_CATEGORY_KEY, LABELLED_INPUT_COMPONENT_KEY, [
	'inputComponent',
]);
